module.exports = __webpack_public_path__ + "img/WB.c04adb8c.png";